export const addFees = (amount, fee) => Math.ceil((fee + 100) * amount / 100)

export const parseShippingEstimate = (min, max) => {
  if (min === max) {
    if (min === 0) return 'Free'

    return `$${Math.round(min / 100)}`
  }

  return `$${Math.round(min / 100)} - $${Math.round(max / 100)}`
}

export const valPhone = (tel) => {
  // eslint-disable-next-line
  const numbers = /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g
  if (tel?.match(numbers)) {
    return true
  } else {
    return false
  }
}

export const valEmail = (email) => {
  const pattern = /^(([^<>()[\].,;:\s@”]+(\.[^<>()[\].,;:\s@”]+)*)|(”.+”))@(([^<>()[\].,;:\s@”]+\.)+[^<>()[\].,;:\s@”]{2,})$/
  return pattern.test(email)
}
